import React, { useState, useEffect } from "react";
import useStyles from "./styles/featured";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { getCFCountry } from "../../helpers/setCookie";

const LOGO_LIST = [
    { src: "/static/new-landing-page/logo/logo_tribunnews.webp", alt: "Logo Tribun News", desktop: { width: 115, height: 48 }, mobile: { width: 90, height: 40 } },
    { src: "/static/new-landing-page/logo/logo_kumparan.webp", alt: "Logo Kumparan", desktop: { width: 103, height: 31 }, mobile: { width: 80, height: 25 } },
    { src: "/static/new-landing-page/logo/logo_okezone.webp", alt: "Logo Okezone", desktop: { width: 87, height: 24 }, mobile: { width: 70, height: 20 } },
    { src: "/static/new-landing-page/logo/logo_liputan6.webp", alt: "Liputan 6", desktop: { width: 106, height: 30 }, mobile: { width: 80, height: 25 } },
    { src: "/static/new-landing-page/logo/logo_suara.com.webp", alt: "Logo Suara.com", desktop: { width: 96, height: 25 }, hideOnMobile: true },
    { src: "/static/new-landing-page/logo/logo_mediaindonesia.webp", alt: "Logo Media Indonesia", desktop: { width: 143, height: 55 }, mobile: { width: 140, height: 40 } },
    { src: "/static/new-landing-page/logo/logo_sindonews.webp", alt: "Logo Sindonews", desktop: { width: 103, height: 25 }, mobile: { width: 80, height: 25 } },
];

const Featured = ({ titleStyle = '' }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [isIndonesia, setIsIndonesia] = useState(true);

    useEffect(() => {
        const cfCountry = getCFCountry();
        if (cfCountry && String(cfCountry).toUpperCase() !== 'ID') {
            setIsIndonesia(false);
        }
    }, []);

    if (!isIndonesia) return null;

    return (
        <div className={classes.root}>
            <span role="heading" aria-level={2} className={titleStyle}>Featured On</span>
            <div className={classes.logoList}>
                {LOGO_LIST.map((logo, index) => (
                    <div className={`${classes.logoItemContainer} ${logo.hideOnMobile ? classes.hideOnMobile : ''}`} key={index}>
                        <img
                            src={logo.src}
                            alt={logo.alt}
                            key={index}
                            loading="lazy"
                            className={`${classes.logoItem}`}
                            style={{ width: isMobile && logo.mobile ? logo.mobile.width : logo.desktop.width, height: isMobile && logo.mobile ? logo.mobile.height : logo.desktop.height, objectFit: 'contain' }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Featured;